// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Gi9p","head":"Table_head__2zYWH","col":"Table_col__1oguy"};